// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qrCode-module_qrCode__vCVT3 {
    box-sizing: border-box;
    /* Quiet zone: keeps the modules away from whatever is painted behind the widget. Set by the widget. */
    padding: var(--qrCodePadding);
    border: 1px solid var(--grey_16_lc);
    border-radius: 17px;
    background: var(--permanent_white);
}

.qrCode-module_qrCode__vCVT3 image {
    clip-path: circle(50%);
}

.qrCode-module_qrCodeClickable__tilEN {
    cursor: pointer;
}

.qrCode-module_qrCodeFullWidth__eNm0O {
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Image/styles/qrCode.module.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,sGAAsG;IACtG,6BAA6B;IAC7B,mCAAmC;IACnC,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":[".qrCode {\n    box-sizing: border-box;\n    /* Quiet zone: keeps the modules away from whatever is painted behind the widget. Set by the widget. */\n    padding: var(--qrCodePadding);\n    border: 1px solid var(--grey_16_lc);\n    border-radius: 17px;\n    background: var(--permanent_white);\n}\n\n.qrCode image {\n    clip-path: circle(50%);\n}\n\n.qrCodeClickable {\n    cursor: pointer;\n}\n\n.qrCodeFullWidth {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 1 / 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"qrCode": `qrCode-module_qrCode__vCVT3`,
	"qrCodeClickable": `qrCode-module_qrCodeClickable__tilEN`,
	"qrCodeFullWidth": `qrCode-module_qrCodeFullWidth__eNm0O`
};
export default ___CSS_LOADER_EXPORT___;
